// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"860":"mobileHome","953":"pcHome"}[chunkId] || chunkId) + "." + {"615":"da62aae3","860":"6769d426","953":"191791d9"}[chunkId] + ".js";
};